import React, { useContext } from 'react';
import { Icon } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import parse from 'html-react-parser';
import { sanitizedAll } from '../../utils/sanitize';
import { useGetDisclaimerQuery } from '../../data/kontentAi';
import { BrandContext } from '../../contextProviders/brandContext';
import { FeatureFlagContext } from '../../contextProviders/featureFlagContext';
import './cspDisclaimer.scss';
import { scrollToTop } from '../../utils/scrollUtils';

const CspDisclaimer = () => {
  const { cspConfiguration } = useContext(FeatureFlagContext);
  const isKontentAiPreviewEnabled = cspConfiguration?.IsKontentAIPreviewEnabled || false;
  const { activeBrandContext } = useContext(BrandContext);
  const { data: disclaimerText } = useGetDisclaimerQuery({
    brandPartner: activeBrandContext.brand.key,
    previewEnabled: isKontentAiPreviewEnabled
  });

  const sanitizedDisclaimer = sanitizedAll(disclaimerText?.content_body);

  const handleBackToTopClicked = () => {
    scrollToTop();
  };

  return (
    <section
      className="disclaimerContainer"
      role="complementary"
      aria-label="Disclaimer section and back to top button"
    >
      <div className="disclaimer">{parse(sanitizedDisclaimer)}</div>
      <button
        type="button"
        className="button secondary backToTopButton"
        onClick={handleBackToTopClicked}
        aria-label=" Back to top"
      >
        Back to top
        <Icon icon="arrow-up2" />
      </button>
    </section>
  );
};

export default CspDisclaimer;
